import React, { Fragment, useState } from "react";
import { Route, Redirect } from "react-router-dom";
import { Layout, PageHeader, Breadcrumb } from "antd";
import { Query } from 'react-apollo';
import { getUserAuthorization } from '../graphql/query/users';
import Sidebar from "../components/common/Sidebar";
//import Navbar from "../components/common/Navbar";
import Auth from "./Auth";
import { Link } from 'react-router-dom';
const { Content } = Layout;

export const PrivateRoute = ({
    component: Component,
    breadcrumb: Breadcrumbs,
    breadcrumbSub: BreadcrumbSub,
    pathB: Path,
    icon: Icon,
    pageTitle: PageTitle,
    auth: Authorization,
    ...rest
}) => {
    let [ user, setUser ] = useState({});
    function getUser(userServe){
        if(user && userServe && userServe.user && userServe.user._id !== user._id){
            setUser(user = userServe.user)
        }
    }

    return(
        <Route
            {...rest}
            render={props => {
                if (Auth.isAuthenticated()){
                    return (
                        <Layout style={{ minHeight: '100vh' }}>
                            <Query 
                                query={getUserAuthorization} 
                                variables={{ _id: localStorage.getItem('@Ossel:userid') }}
                            >
                                {({ loading, error, data, refetch }) => {
                                    getUser(data)
                                    return(
                                        <Fragment>
                                            <Layout>
                                                <Sidebar user={user}/>
                                                <Layout style={{ padding: '0 24px 24px', marginLeft: 80 }}>
                                                
                                                    <Breadcrumb style={{ marginLeft: 25, marginTop: 20 }}>
                                                        { Path ? 
                                                                <Breadcrumb.Item>
                                                                    <Icon style={{marginRight: 10}}/>
                                                                    <span>
                                                                        <Link to={Path}>
                                                                            {Breadcrumbs}
                                                                        </Link>
                                                                    </span>
                                                                </Breadcrumb.Item>
                                                            : 
                                                                <Breadcrumb.Item>
                                                                    <Icon style={{marginRight: 10}}/>
                                                                    <span>
                                                                        {Breadcrumbs}
                                                                    </span>
                                                                </Breadcrumb.Item>
                                                        }
                                                        
                                                        { BreadcrumbSub ? <Breadcrumb.Item><span>{BreadcrumbSub}</span></Breadcrumb.Item> : null }
                                                    </Breadcrumb>
                    
                    
                                                    <PageHeader title={PageTitle}/>
                                                    
                                                    <Content 
                                                        style={{
                                                            background: '#fff', 
                                                            padding: 24, 
                                                            marginRight: 20, 
                                                            marginLeft: 20, 
                                                            marginBottom: 20, 
                                                            minHeight: "auto" 
                                                        }}
                                                    >
                                                        <Component {...props} user={user}/>
                                                    </Content>
                                                </Layout>
                                            </Layout>
                                        </Fragment>
                                    )
                                }}
                            </Query>
                        </Layout>
                    );
                }else{
                    return(
                        <Redirect
                            to={{
                                pathname: "/login",
                                state: {
                                    from: props.location
                                }
                            }}
                        />
                    )
                } 
            }}
        />
    )
}


// WEBPACK FOOTER //
// ./src/auth/PrivateRoute.jsx